
class CountryList {
    getCountryList(){
        return  [

            { caption: 'United States', value: 'US' },
            { caption: 'Canada', value: 'CA' },
            { caption: 'United Kingdom', value: 'GB' },
            { caption: '---', value: '00' },
            { caption: 'Afghanistan', value: 'AF' },
            { caption: 'Åland Islands', value: 'AX' },
            { caption: 'Albania', value: 'AL' },
            { caption: 'Algeria', value: 'DZ' },
            { caption: 'American Samoa', value: 'AS' },
            { caption: 'Andorra', value: 'AD' },
            { caption: 'Angola', value: 'AO' },
            { caption: 'Anguilla', value: 'AI' },
            { caption: 'Antarctica', value: 'AQ' },
            { caption: 'Antigua and Barbuda', value: 'AG' },
            { caption: 'Argentina', value: 'AR' },
            { caption: 'Armenia', value: 'AM' },
            { caption: 'Aruba', value: 'AW' },
            { caption: 'Australia', value: 'AU' },
            { caption: 'Austria', value: 'AT' },
            { caption: 'Azerbaijan', value: 'AZ' },
            { caption: 'Bahamas', value: 'BS' },
            { caption: 'Bahrain', value: 'BH' },
            { caption: 'Bangladesh', value: 'BD' },
            { caption: 'Barbados', value: 'BB' },
            { caption: 'Belarus', value: 'BY' },
            { caption: 'Belgium', value: 'BE' },
            { caption: 'Belize', value: 'BZ' },
            { caption: 'Benin', value: 'BJ' },
            { caption: 'Bermuda', value: 'BM' },
            { caption: 'Bhutan', value: 'BT' },
            { caption: 'Bolivia', value: 'BO' },
            { caption: 'Bosnia and Herzegovina', value: 'BA' },
            { caption: 'Botswana', value: 'BW' },
            { caption: 'Bouvet Island', value: 'BV' },
            { caption: 'Brazil', value: 'BR' },
            { caption: 'British Indian Ocean Territory', value: 'IO' },
            { caption: 'Brunei Darussalam', value: 'BN' },
            { caption: 'Bulgaria', value: 'BG' },
            { caption: 'Burkina Faso', value: 'BF' },
            { caption: 'Burundi', value: 'BI' },
            { caption: 'Cambodia', value: 'KH' },
            { caption: 'Cameroon', value: 'CM' },
            { caption: 'Cape Verde', value: 'CV' },
            { caption: 'Cayman Islands', value: 'KY' },
            { caption: 'Central African Republic', value: 'CF' },
            { caption: 'Chad', value: 'TD' },
            { caption: 'Chile', value: 'CL' },
            { caption: 'China', value: 'CN' },
            { caption: 'Christmas Island', value: 'CX' },
            { caption: 'Cocos (Keeling) Islands', value: 'CC' },
            { caption: 'Colombia', value: 'CO' },
            { caption: 'Comoros', value: 'KM' },
            { caption: 'Congo', value: 'CG' },
            { caption: 'Congo, The Democratic Republic of the', value: 'CD' },
            { caption: 'Cook Islands', value: 'CK' },
            { caption: 'Costa Rica', value: 'CR' },
            { caption: 'Cote D\'Ivoire', value: 'CI' },
            { caption: 'Croatia', value: 'HR' },
            { caption: 'Cuba', value: 'CU' },
            { caption: 'Cyprus', value: 'CY' },
            { caption: 'Czech Republic', value: 'CZ' },
            { caption: 'Denmark', value: 'DK' },
            { caption: 'Djibouti', value: 'DJ' },
            { caption: 'Dominica', value: 'DM' },
            { caption: 'Dominican Republic', value: 'DO' },
            { caption: 'Ecuador', value: 'EC' },
            { caption: 'Egypt', value: 'EG' },
            { caption: 'El Salvador', value: 'SV' },
            { caption: 'Equatorial Guinea', value: 'GQ' },
            { caption: 'Eritrea', value: 'ER' },
            { caption: 'Estonia', value: 'EE' },
            { caption: 'Ethiopia', value: 'ET' },
            { caption: 'Falkland Islands (Malvinas)', value: 'FK' },
            { caption: 'Faroe Islands', value: 'FO' },
            { caption: 'Fiji', value: 'FJ' },
            { caption: 'Finland', value: 'FI' },
            { caption: 'France', value: 'FR' },
            { caption: 'French Guiana', value: 'GF' },
            { caption: 'French Polynesia', value: 'PF' },
            { caption: 'French Southern Territories', value: 'TF' },
            { caption: 'Gabon', value: 'GA' },
            { caption: 'Gambia', value: 'GM' },
            { caption: 'Georgia', value: 'GE' },
            { caption: 'Germany', value: 'DE' },
            { caption: 'Ghana', value: 'GH' },
            { caption: 'Gibraltar', value: 'GI' },
            { caption: 'Greece', value: 'GR' },
            { caption: 'Greenland', value: 'GL' },
            { caption: 'Grenada', value: 'GD' },
            { caption: 'Guadeloupe', value: 'GP' },
            { caption: 'Guam', value: 'GU' },
            { caption: 'Guatemala', value: 'GT' },
            { caption: 'Guernsey', value: 'GG' },
            { caption: 'Guinea', value: 'GN' },
            { caption: 'Guinea-Bissau', value: 'GW' },
            { caption: 'Guyana', value: 'GY' },
            { caption: 'Haiti', value: 'HT' },
            { caption: 'Heard Island and Mcdonald Islands', value: 'HM' },
            { caption: 'Holy See (Vatican City State)', value: 'VA' },
            { caption: 'Honduras', value: 'HN' },
            { caption: 'Hong Kong', value: 'HK' },
            { caption: 'Hungary', value: 'HU' },
            { caption: 'Iceland', value: 'IS' },
            { caption: 'India', value: 'IN' },
            { caption: 'Indonesia', value: 'ID' },
            { caption: 'Iran, Islamic Republic Of', value: 'IR' },
            { caption: 'Iraq', value: 'IQ' },
            { caption: 'Ireland', value: 'IE' },
            { caption: 'Isle of Man', value: 'IM' },
            { caption: 'Israel', value: 'IL' },
            { caption: 'Italy', value: 'IT' },
            { caption: 'Jamaica', value: 'JM' },
            { caption: 'Japan', value: 'JP' },
            { caption: 'Jersey', value: 'JE' },
            { caption: 'Jordan', value: 'JO' },
            { caption: 'Kazakhstan', value: 'KZ' },
            { caption: 'Kenya', value: 'KE' },
            { caption: 'Kiribati', value: 'KI' },
            { caption: 'Democratic People\'s Republic of Korea', value: 'KP' },
            { caption: 'Korea, Republic of', value: 'KR' },
            { caption: 'Kosovo', value: 'XK' },
            { caption: 'Kuwait', value: 'KW' },
            { caption: 'Kyrgyzstan', value: 'KG' },
            { caption: 'Lao People\'s Democratic Republic', value: 'LA' },
            { caption: 'Latvia', value: 'LV' },
            { caption: 'Lebanon', value: 'LB' },
            { caption: 'Lesotho', value: 'LS' },
            { caption: 'Liberia', value: 'LR' },
            { caption: 'Libyan Arab Jamahiriya', value: 'LY' },
            { caption: 'Liechtenstein', value: 'LI' },
            { caption: 'Lithuania', value: 'LT' },
            { caption: 'Luxembourg', value: 'LU' },
            { caption: 'Macao', value: 'MO' },
            { caption: 'Macedonia, The Former Yugoslav Republic of', value: 'MK' },
            { caption: 'Madagascar', value: 'MG' },
            { caption: 'Malawi', value: 'MW' },
            { caption: 'Malaysia', value: 'MY' },
            { caption: 'Maldives', value: 'MV' },
            { caption: 'Mali', value: 'ML' },
            { caption: 'Malta', value: 'MT' },
            { caption: 'Marshall Islands', value: 'MH' },
            { caption: 'Martinique', value: 'MQ' },
            { caption: 'Mauritania', value: 'MR' },
            { caption: 'Mauritius', value: 'MU' },
            { caption: 'Mayotte', value: 'YT' },
            { caption: 'Mexico', value: 'MX' },
            { caption: 'Micronesia, Federated States of', value: 'FM' },
            { caption: 'Moldova, Republic of', value: 'MD' },
            { caption: 'Monaco', value: 'MC' },
            { caption: 'Mongolia', value: 'MN' },
            { caption: 'Montenegro', value: 'ME' },
            { caption: 'Montserrat', value: 'MS' },
            { caption: 'Morocco', value: 'MA' },
            { caption: 'Mozambique', value: 'MZ' },
            { caption: 'Myanmar', value: 'MM' },
            { caption: 'Namibia', value: 'NA' },
            { caption: 'Nauru', value: 'NR' },
            { caption: 'Nepal', value: 'NP' },
            { caption: 'Netherlands', value: 'NL' },
            { caption: 'Netherlands Antilles', value: 'AN' },
            { caption: 'New Caledonia', value: 'NC' },
            { caption: 'New Zealand', value: 'NZ' },
            { caption: 'Nicaragua', value: 'NI' },
            { caption: 'Niger', value: 'NE' },
            { caption: 'Nigeria', value: 'NG' },
            { caption: 'Niue', value: 'NU' },
            { caption: 'Norfolk Island', value: 'NF' },
            { caption: 'Northern Mariana Islands', value: 'MP' },
            { caption: 'Norway', value: 'NO' },
            { caption: 'Oman', value: 'OM' },
            { caption: 'Pakistan', value: 'PK' },
            { caption: 'Palau', value: 'PW' },
            { caption: 'Palestinian Territory, Occupied', value: 'PS' },
            { caption: 'Panama', value: 'PA' },
            { caption: 'Papua New Guinea', value: 'PG' },
            { caption: 'Paraguay', value: 'PY' },
            { caption: 'Peru', value: 'PE' },
            { caption: 'Philippines', value: 'PH' },
            { caption: 'Pitcairn', value: 'PN' },
            { caption: 'Poland', value: 'PL' },
            { caption: 'Portugal', value: 'PT' },
            { caption: 'Puerto Rico', value: 'PR' },
            { caption: 'Qatar', value: 'QA' },
            { caption: 'Reunion', value: 'RE' },
            { caption: 'Romania', value: 'RO' },
            { caption: 'Russian Federation', value: 'RU' },
            { caption: 'Rwanda', value: 'RW' },
            { caption: 'Saint Helena', value: 'SH' },
            { caption: 'Saint Kitts and Nevis', value: 'KN' },
            { caption: 'Saint Lucia', value: 'LC' },
            { caption: 'Saint Pierre and Miquelon', value: 'PM' },
            { caption: 'Saint Vincent and the Grenadines', value: 'VC' },
            { caption: 'Samoa', value: 'WS' },
            { caption: 'San Marino', value: 'SM' },
            { caption: 'Sao Tome and Principe', value: 'ST' },
            { caption: 'Saudi Arabia', value: 'SA' },
            { caption: 'Senegal', value: 'SN' },
            { caption: 'Serbia', value: 'RS' },
            { caption: 'Seychelles', value: 'SC' },
            { caption: 'Sierra Leone', value: 'SL' },
            { caption: 'Singapore', value: 'SG' },
            { caption: 'Slovakia', value: 'SK' },
            { caption: 'Slovenia', value: 'SI' },
            { caption: 'Solomon Islands', value: 'SB' },
            { caption: 'Somalia', value: 'SO' },
            { caption: 'South Africa', value: 'ZA' },
            { caption: 'South Georgia and the South Sandwich Islands', value: 'GS' },
            { caption: 'Spain', value: 'ES' },
            { caption: 'Sri Lanka', value: 'LK' },
            { caption: 'Sudan', value: 'SD' },
            { caption: 'Suriname', value: 'SR' },
            { caption: 'Svalbard and Jan Mayen', value: 'SJ' },
            { caption: 'Swaziland', value: 'SZ' },
            { caption: 'Sweden', value: 'SE' },
            { caption: 'Switzerland', value: 'CH' },
            { caption: 'Syrian Arab Republic', value: 'SY' },
            { caption: 'Taiwan', value: 'TW' },
            { caption: 'Tajikistan', value: 'TJ' },
            { caption: 'Tanzania, United Republic of', value: 'TZ' },
            { caption: 'Thailand', value: 'TH' },
            { caption: 'Timor-Leste', value: 'TL' },
            { caption: 'Togo', value: 'TG' },
            { caption: 'Tokelau', value: 'TK' },
            { caption: 'Tonga', value: 'TO' },
            { caption: 'Trinidad and Tobago', value: 'TT' },
            { caption: 'Tunisia', value: 'TN' },
            { caption: 'Turkey', value: 'TR' },
            { caption: 'Turkmenistan', value: 'TM' },
            { caption: 'Turks and Caicos Islands', value: 'TC' },
            { caption: 'Tuvalu', value: 'TV' },
            { caption: 'Uganda', value: 'UG' },
            { caption: 'Ukraine', value: 'UA' },
            { caption: 'United Arab Emirates', value: 'AE' },
            { caption: 'United States Minor Outlying Islands', value: 'UM' },
            { caption: 'Uruguay', value: 'UY' },
            { caption: 'Uzbekistan', value: 'UZ' },
            { caption: 'Vanuatu', value: 'VU' },
            { caption: 'Venezuela', value: 'VE' },
            { caption: 'Viet Nam', value: 'VN' },
            { caption: 'Virgin Islands, British', value: 'VG' },
            { caption: 'Virgin Islands, U.S.', value: 'VI' },
            { caption: 'Wallis and Futuna', value: 'WF' },
            { caption: 'Western Sahara', value: 'EH' },
            { caption: 'Yemen', value: 'YE' },
            { caption: 'Zambia', value: 'ZM' },
            { caption: 'Zimbabwe', value: 'ZW' }
        ];
    }
}

const countries = new CountryList;
export default countries;